import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
} from '@mui/material';
import {
  Notes as NotesIcon,
  Check as CheckIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import SoftTypography from 'components/SoftTypography';
import SoftInput from 'components/SoftInput';
import SoftButton from 'components/SoftButton';
import useAddNote from '../useAddNote';

const AddNotesModal = ({onClose, open, policyDetails}) => {
  const { t } = useTranslation();
  const [note, setNote] = useState('');
  const { addNote } = useAddNote();


  const addNoteHandler = () => {
    addNote(policyDetails?.bookingDataId, note);
    setNote('');
    onClose();
  }

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>
        <SoftTypography>
          <NotesIcon sx={{ paddingTop: '0.3rem' }} />{' '}
          {t('POLICY_DETAILS.NOTES.title')}
        </SoftTypography>
      </DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <SoftInput
            autoFocus
            label={t('POLICY_DETAILS.NOTES.placeholder')}
            placeholder={t('POLICY_DETAILS.NOTES.placeholder')}
            multiline
            rows={4}
            onChange={(e) => setNote(e.target.value)}
            value={note}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <SoftButton
          size="small"
          onClick={() => {
            setNote('');
            onClose()
          }}
        >
          <CloseIcon sx={{ marginRight: '0.2rem' }} />
          {t('COMMON.cancel')}
        </SoftButton>
        <SoftButton
          size="small"
          type="submit"
          color="success"
          disabled={!note}
          onClick={addNoteHandler}
        >
          <CheckIcon sx={{ marginRight: '0.2rem' }} />
          {t('COMMON.save')}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
};

AddNotesModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  policyDetails: PropTypes.object.isRequired,
};

export default AddNotesModal;